module.exports = __webpack_public_path__ + "static/img/strona_005.0e5d4425.jpg";